<template>
  <div class="grid-document-header" ref="docHeader">
    <div class="document-logo">
      <div class="document-author-logo">
        <img v-if="clientLogoPath" :src="clientLogoPath" :alt="client.name" />
      </div>
    </div>

    <div class="document-header-right">
      <div class="document-author-address">
        <div class="address-line">{{ client.name }}</div>
        <div class="address-line">{{ client.street }}</div>
        <div class="address-line">{{ zipCityLine }}</div>
        <div class="address-line"></div>
        <div class="address-line">{{ phoneLine }}</div>
        <div class="address-line">{{ client.email }}</div>
        <div class="address-line">{{ client.website }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientLogoPath } from '@/helpers/clientLogo';

export default {
  name: 'PrintHeaderClient',
  props: {
    project: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    client() {
      if (!this.project || !this.project.client) {
        return {};
      }
      return this.project.client;
    },
    clientLogoPath() {
      return getClientLogoPath(this.client);
    },
    zipCityLine() {
      const zip = this.client.zip || '';
      const city = this.client.city || '';
      return `${zip} ${city}`.trim();
    },
    phoneLine() {
      if (!this.client.phone) {
        return '';
      }
      return `Tel: ${this.client.phone}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-document-header {
  margin: 1cm 1cm 0.5cm 1cm;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 1em;
}
.document-logo {
  text-align: left;
}
.document-author-logo {
  width: 200px;
  min-height: 60px;
}
.document-logo img {
  width: 200px;
  display: block;
}
.document-header-right {
  text-align: right;
}

.document-author-address {
  line-height: 1.2em;
  text-align: right;
  font-size: 11px;
  color: $gray-600;
}
.address-line {
  min-height: 1.2em;
}
</style>
